import React from "react";
import { Link } from "react-router-dom";
import "./Healthblog.css";

const Healthblog = () => {
  return (
    <section className="hero-section">
    <div style={{margin: "auto", maxWidth: "800px"}}>
      <div data-aos="fade-up" className="flex-hero">
        <h2>Improve Your Diet Starting Today</h2>{" "}
        <p>
          There are many foods that we love to eat but just are not healthy enough
          to indulge infrequently. Burgers, fries, and sweets are among some of
          our go-to food favorites. Eating these kinds of foods often can lead to
          a poor diet and some serious health issues.
          <br /> <span id="more-37723" />
        </p>{" "}
        <h2>Ready to improve your diet?</h2>{" "}
        <p>
          Luckily, there are ways to indulge in these foods healthily without
          feeling guilty. Check out this list of{" "}
          <a
            href="https://diyactive.com/five-ways-your-pet-can-improve-your-physical-and-mental-health/"
            data-wpel-link="internal"
          >
            ways you can improve
          </a>{" "}
          your diet without cutting out your favorite foods!
        </p>{" "}
        <h3>1. Try a Non-Beef Burger Option</h3>{" "}
        <p>
          Burgers are uncontestably delicious. Typically, most burgers are made
          with beef, but this does not have to be the case. Eating a large amount
          of red meat can take a toll on your digestive system.
        </p>{" "}
        <p>
          There are lots of healthier options to a standard beef burger,{" "}
          <a
            href="https://diyactive.com/turkey-burgers-with-peaches/"
            data-wpel-link="internal"
          >
            including turkey burgers
          </a>{" "}
          and various different veggie burger options, like veggie patties or
          portobello mushroom and halloumi.
        </p>{" "}
        <p>
          If you are an avid burger lover, think about trying one of these
          alternative options next time you are hosting a cookout.
        </p>{" "}
        <h3>2. Buy an Air Fryer</h3>{" "}
        <p>
          It is a well-known fact that fried foods are full of fat and an excess
          of oil that is unhealthy for the body.
        </p>{" "}
        <p>
          This being said, fried foods are also delicious, and it can be difficult
          to find the willpower to completely cut them out of your diet. Instead
          of frying your next batch of foods in a traditional fryer, think about
          purchasing an air fryer for your frying needs.
        </p>{" "}
        <p>
          Air fryers give you a way to fry your food without any oil at all. Air
          fryers are extremely easy to use and are a great way to enjoy your
          favorite fried treats without the unhealthy consequences.
        </p>{" "}
        <h3>3. Incorporate Fruits into Your Desserts</h3>{" "}
        <p>
          We love a dessert because it’s a sweet snack to enjoy at the end of a
          long day. However, sweets can quickly become unhealthy when not eaten in
          moderation due to their high sugar content.
        </p>{" "}
        <p>
          Next time you are thinking about dessert, consider eating fruit instead
          or incorporating fruits into your dessert. Using fruits and their
          natural sugars can help cut out the added sugar in desserts. This is a
          great way to enjoy a sweet snack without feeling guilty.
        </p>{" "}
        <h3>4. Reduce Your Salt Intake</h3>{" "}
        <p>
          Too much sodium can increase your blood pressure and the frequency of
          your sugar cravings. Most of us are eating far more salt than the daily
          1,500 milligrams recommended.
        </p>{" "}
        <p>
          Next time you are cooking, try being mindful of the amount of salt you
          are adding to your food.
        </p>{" "}
        <h3>5. Use the Peels of Vegetables</h3>{" "}
        <p>
          Vegetable peels are full of vitamins and nutrients that are often wasted
          because we throw them away.
        </p>{" "}
        <p>
          Incorporating the peels of all kinds of vegetables and other foods can
          easily increase the number of nutrients in your diet. Often, the skins
          offer more nutrients than what’s inside! Next time you want potato
          fries, try making your own with the skins on.
        </p>{" "}
        <p>
          This is an easy way to reduce waste and improve your diet at the same
          time.
        </p>
        <h3>6. Try Eating Anti-Inflammatory Foods</h3>{" "}
        <p>
          There are many{" "}
          <a
            href="https://diyactive.com/7-natural-anti-inflammatory-foods-to-ease-arthritis-pain/"
            data-wpel-link="internal"
          >
            anti-inflammatory foods
          </a>{" "}
          that we already love, so it is easy to incorporate them into your diet
          more frequently.
        </p>{" "}
        <p>
          These foods have more omega-3 acids compared to others, which helps
          increase your immune system. Some of our favorite anti-inflammatory
          foods include walnuts, salmon, tofu, and flaxseeds.
        </p>{" "}
        <h3>7. Try Out Meatless Monday</h3>{" "}
        <p>
          Incorporating one vegetarian meal into your diet a week can help improve
          your health greatly. The idea is that by ditching the meat once a week,
          you are ultimately increasing your vegetable intake.
        </p>{" "}
        <p>
          We suggest trying out a stuffed bell pepper with risotto, making your
          own healthy veggie pizzas, or making a large and delicious salad to
          start out your meatless Mondays.
        </p>{" "}
        <h2>Wrap-Up</h2>{" "}
        <p>
          So, are you ready to start improving your diet? Start with small, baby
          steps and grow from there!
        </p>
      </div>
    </div>
  </section>
  
  );
};

export default Healthblog;